:host {
  display: block;
}

.signet-select {
  font-family: Lato, Helvetica, Arial, sans-serif;
  position: relative;
  display: inline-block;
  width: 100%;

  &[size='sm'] .select,
  &.signet-select--sm .select {
    padding: 15px 12px;
    .icons{
      top: 60%;
    }
    .floating-label-bg{
      top: 7px;
    }
  }

  &[size='lg'] .select,
  &.signet-select--lg .select {
    padding: 25px 12px;
    .icons{
      top: 60%;
    }
    .floating-label-bg{
      top: 10px;
    }
  }

  &.signet-select--sm .select .select-label-open{
    top: -10px;
  }

  .select {
    border: 1px solid var(--gray-400);
    padding: 20px 12px;
    border-radius: 4px;
    cursor: pointer;
    outline: 0;
    transition: all 0.25 ease-in-out;
    appearance: none;
    position: relative;
    background: transparent;

    

    .select-label {
      position: absolute;
      top: 50%;
      left: 15px;
      pointer-events: none;
      transition: all 0.25s ease-in-out;
      transform: translateY(-50%);
      font-size: 0.875rem;
      font-weight: 400;
      color: var(--gray-500);
    }

    .select-label-open {
      position: absolute;
      top: -25%;
      left: 10px;
      padding: 3px 10px;
      font-size: 0.75rem;
      background: transparent;
      color: var(--primary-main);
      transition: all 0.25s ease-in-out;
      pointer-events: none;
      z-index: 99;
      font-weight: 400;

      // &:before {
      //   content: "";
      //   position: absolute;
      //   height: 6px;
      //   bottom: 8px;
      //   z-index: -1;
      //   width: 120%;
      //   display: block;
      //   left: -2px;
      //   background: var(--pure-white);
      // }
    }
    
    .floating-label-bg{
      width: 100%;
      display: block;
      position: absolute;
      height: 4px;
      left: 0px;
      top: 8px;
      padding: 0 0px;
      z-index: -1;
    }

    .select-value {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 15px;
      font-size: 0.875rem;
      line-height: 1.75;
      white-space: nowrap;
      pointer-events: none;
      font-weight: 400;
      text-overflow: ellipsis;
    }

    .icons {
      position: absolute;
      top: 50%;
      right: 10px !important;
      transform: translateY(-50%);

      .select-icon {
        pointer-events: none;
        color: var(--primary-main);
      }

      .search-icon {
        pointer-events: none;
        color: var(--primary-main);
      }
    }

    &[aria-expanded="true"] .select-icon {
      transform: rotate(-180deg);
      transition: all 0.3s ease-in-out;
    }

    &[aria-disabled="true"] {
      background-color: var(--gray-50);
      border-color: var(--gray-400);
      cursor: not-allowed;
    }

    &[aria-disabled="true"] .select-label-open {
      color: var(--gray-400);

      // &:before {
      //   content: "";
      //   position: absolute;
      //   height: 6px;
      //   bottom: 8px;
      //   z-index: -1;
      //   width: 100%;
      //   display: block;
      //   left: -2px;
      //   background: var(--pure-white);
      // }
    }
  }

  .select-contents {
    display: flex;
    flex-direction: column;
    visibility: hidden;
    opacity: 0;
    left: 0;
    position: absolute;
    list-style: none;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    overflow-x: auto;
    background-color: white;
    border-radius: 4px;
    z-index: 100;
    transition: all 0.3s ease-in-out;

    .select-option {
      padding: 12px 15px;
      cursor: pointer;
      font-weight: 400;

      &:hover {
        background-color: var(--gray-100);
      }

      > * {
        display: inline-block;
      }
    }

    .select-option-selected {
      padding: 12px 15px;
      cursor: pointer;
      font-weight: 400;
      background-color: var(--gray-100);

      &:hover {
        background-color: var(--gray-200);
      }

      > * {
        display: inline-block;
      }
    }
  }

  &.show-select-contents {
    .select-contents-container {
      visibility: visible;
      opacity: 1;
      background: var(--pure-white);
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12);
      transition: all 0.3s ease-in-out;
    }

    .select-contents {
      display: flex;
      flex-direction: column;
    }
  }
}

span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: rgba(255, 255, 255, 0.3);
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}
